var __extends = globalThis && globalThis.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d2, b2) {
      d2.__proto__ = b2;
    } || function (d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var ErrorCode;

(function (ErrorCode2) {
  ErrorCode2["MISSING_VALUE"] = "MISSING_VALUE";
  ErrorCode2["INVALID_VALUE"] = "INVALID_VALUE";
  ErrorCode2["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));

var FormatError =
/** @class */
function (_super) {
  __extends(FormatError2, _super);

  function FormatError2(msg, code, originalMessage) {
    var _this = _super.call(this, msg) || this;

    _this.code = code;
    _this.originalMessage = originalMessage;
    return _this;
  }

  FormatError2.prototype.toString = function () {
    return "[formatjs Error: " + this.code + "] " + this.message;
  };

  return FormatError2;
}(Error);

var InvalidValueError =
/** @class */
function (_super) {
  __extends(InvalidValueError2, _super);

  function InvalidValueError2(variableId, value, options, originalMessage) {
    return _super.call(this, 'Invalid values for "' + variableId + '": "' + value + '". Options are "' + Object.keys(options).join('", "') + '"', "INVALID_VALUE", originalMessage) || this;
  }

  return InvalidValueError2;
}(FormatError);

var InvalidValueTypeError =
/** @class */
function (_super) {
  __extends(InvalidValueTypeError2, _super);

  function InvalidValueTypeError2(value, type, originalMessage) {
    return _super.call(this, 'Value for "' + value + '" must be of type ' + type, "INVALID_VALUE", originalMessage) || this;
  }

  return InvalidValueTypeError2;
}(FormatError);

var MissingValueError =
/** @class */
function (_super) {
  __extends(MissingValueError2, _super);

  function MissingValueError2(variableId, originalMessage) {
    return _super.call(this, 'The intl string context variable "' + variableId + '" was not provided to the string "' + originalMessage + '"', "MISSING_VALUE", originalMessage) || this;
  }

  return MissingValueError2;
}(FormatError);

export { ErrorCode, FormatError, InvalidValueError, InvalidValueTypeError, MissingValueError };